<template>
  <v-container class="grey lighten-5 mb-6" fluid>
    <v-row>
      <v-col class="main-col-margin">
        <v-card class="mx-auto">
          <v-card-title
            class="main-card-title-offset"
          >
            <v-icon large left color="white"> mdi-format-list-bulleted </v-icon>
            <span class="title">
              {{ $t('sectorApplication.list.title') }}
            </span>
            <v-spacer></v-spacer>

            <v-btn icon @click="createSectorApplication()">
              <v-icon color="white">mdi-plus-circle-outline</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-data-table
            :headers="headers"
            :items="sectorApplications"
            :sort-by="[]"
            :sort-desc="[false, true]"
            multi-sort
            class="elevation-1"
            :loading="isLoading"
            :loading-text="$t('sectorApplication.list.loading')"
          >
            <template v-slot:[`item.image_path`]="props">
              <v-img
                :src="props.item.image_path"
                class="sector-datatable-image"
              ></v-img>
            </template>

            <template v-slot:[`item.translations`]="props">
              <span
                v-for="translations in props.item.translations"
                :key="translations.id"
              >
                <span v-for="translations in props.item.translations" :key="translations.id">
                <flag :iso="languages[translations.language].flag" class="translation-flags"/>
              </span>
              </span>
            </template>
            
            <template v-slot:[`item.controls`]="props">
              <v-btn
                class="mx-2"
                fab
                dark
                small
                color="warning"
                @click="editSectorApplication(props.item)"
              >
                <v-icon dark>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                fab
                dark
                small
                color="error"
                @click="openDeleteSectorApplicationDialog(props.item)"
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ $t('sectorApplication.list.delete.title') }}
          </v-card-title>
          <v-card-text>
            {{ $t('sectorApplication.list.delete.description') }}
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-row class="text-center" style="margin: 0px">
              <v-col>
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  small
                  color="error"
                  text
                  @click="deleteSector()"
                >
                  <v-icon dark>mdi-delete</v-icon>
                  {{ $t('sectorApplication.list.delete.controlls.delete') }}
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  class="mx-2"
                  fab
                  dark
                  small
                  color="primary"
                  text
                  @click="closeDeleteSectorApplicationDialog()"
                >
                  <v-icon dark>mdi-close-circle</v-icon>
                  {{ $t('sectorApplication.list.delete.controlls.cancel') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <error-handler :error="error"></error-handler>
  </v-container>
</template>
<script>
export default {
  name: "ListSectorApplications",
  data() {
    return {
      error: null,
      isLoading: true,
      headers: [
        {
          text: this.$t('sectorApplication.list.label.internalName'),
          align: "start",
          value: "internal_name",
          sortable: true,
        },
        { text: this.$t('sectorApplication.list.label.image'), value: "image_path", sortable: false },
        { text: this.$t('sectorApplication.list.label.translations'), value: "translations", sortable: false },
        {
          text: this.$t('sectorApplication.list.label.actions'),
          value: "controls",
          sortable: false,
          align: "center",
        },
      ],
      sectorApplications: [],
      dialog: false,
      deletingSectorApplication: null,
    };
  },
  computed: {
    applicationData() {
      return this.$store.state.applicationData
    },
    languages() {
      if(this.applicationData) {
        return this.applicationData.crm_languages; 
      }
      return []
    }
  },
  mounted() {
    this.$store.dispatch('loadApplicationData')
    this.fetchSectorApplications();
  },

  methods: {
    fetchSectorApplications() {
      this.$axios({
        method: "get",
        url: this.$globals.api.sectorApplication.getAll,
      })
        .then((response) => {
          this.sectorApplications = response.data.data;
          this.isLoading = false;
        })
        .catch((error) => {
          this.error = error.response;
        });
    },
    createSectorApplication() {
      this.$router.push({ name: "sector-application/add" });
    },
    editSectorApplication(sectorApplication) {
      this.$router.push({
        name: "sector-application/edit",
        params: { id: sectorApplication.id },
      });
    },
    openDeleteSectorApplicationDialog(sectorApplication) {
      this.dialog = true;
      this.deletingSectorApplication = sectorApplication;
    },
    closeDeleteSectorApplicationDialog() {
      this.dialog = false;
      this.deletingSectorApplication = null;
    },
    deleteSector() {
      this.$axios({
        method: "post",
        url:
          this.$globals.api.sectorApplication.delete +
          this.deletingSectorApplication.id,
      })
        .then(() => {
          this.deletingSectorApplication = null;
          this.dialog = false;
          this.isLoading = true;
          this.fetchSectorApplications();
        })
        .catch((error) => {
          this.error = error.response;
        });
    },
  },
};
</script>